:host{height:100%}.filter-active{color:#5a42d0}.annotation-section.with-class-selector{grid-template-rows:0 100%}.annotation-section{display:grid;grid-template-rows:50% 50%;height:100%}.with-class-selector{grid-template-rows:0 100%}
/*# sourceMappingURL=annotation-panel.component.css.map */
